import { getInterestRate } from '@atc/wallet-payment-fns';
async function calculateTotalBudget(_ref) {
  let {
    payload,
    paymentsInfo,
    paymentCalculationFetcher
  } = _ref;
  const paymentsState = {
    ...paymentsInfo,
    ...payload
  };
  const {
    loanTerm,
    monthlyBudget = 0,
    tradeIn,
    interestRate,
    downPayment,
    downPaymentPercent
  } = paymentsState;
  const tradeInParam = tradeIn?.value || 0;
  const amountOwedParam = tradeIn?.amountOwed || 0;
  const interestRateParam = getInterestRate(interestRate);
  const downPaymentParam = downPayment ? `downPayment=${downPayment}` : `downPaymentPercent=${downPaymentPercent * 100}`;
  const budgetApiParams = `monthlyPayment=${monthlyBudget}&tradeInValue=${tradeInParam}&amountOwed=${amountOwedParam}&loanTerm=${loanTerm}&interestRate=${interestRateParam}&${downPaymentParam}`;
  const {
    totalBudget
  } = (await paymentCalculationFetcher.fetch(budgetApiParams, true)) || {};
  return totalBudget;
}
export { calculateTotalBudget as default };
